import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ReportDesignerItemTags } from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-form-renderer-tags",
  templateUrl: "report-form-renderer-tags.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererTagsComponent {
  @Input()
  item!: ReportDesignerItemTags;

  @Output() value: EventEmitter<string[]> = new EventEmitter();

  formData: { tags: string[] } = { tags: [] };

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "tags",
      config: {
        title: this.item.config.title,
        value: this.formData.tags
      }
    };
  }

  onFieldDataChanged({
    value,
    dataField
  }: {
    value: string[];
    dataField: string;
  }): void {
    this.value.emit(value);
  }
}
